import { KeeperDetailsField } from 'Components/pages/VehicleDetailsRedesign/sections/VehicleDetailsSection/PreviousOwnersFieldValue/KeeperDetails/KeeperDetailsField';
import { FALLBACK } from 'Pages/vehicles/schemas/schema.const';
import { triggerKeeperDetailsModalCloseEvent, triggerKeeperDetailsModalOpenEvent } from 'Services/analytics/events';

import { useVehicleMainInfo } from '../../MainInfoSection/useVehicleMainInfo';
import { useVehicleDetails } from '../useVehicleDetails';

const events = {
	onModalClose: triggerKeeperDetailsModalCloseEvent,
	onModalOpen: triggerKeeperDetailsModalOpenEvent,
};

export const PreviousOwnersFieldValue: React.FC = () => {
	const { make, model, prettyVrm } = useVehicleMainInfo();
	const { previousOwners, vrm } = useVehicleDetails();

	if (typeof previousOwners.count !== 'number') {
		return <>{FALLBACK}</>;
	}

	return (
		<KeeperDetailsField
			events={events}
			keepersList={previousOwners.keepers}
			make={make}
			model={model}
			prettyVrm={prettyVrm}
			previousKeepersCount={previousOwners.count}
			vrm={vrm}
		/>
	);
};
